import React from 'react'
import '../css/TermsConditions.css'

function TermsConditions() {
  return (
    <div className="terms-container">
      <div className="terms-wrapper">
        <header className="terms-header">
          <h1 className="terms-title">Terms & Conditions</h1>
          <p className="terms-effective-date">Effective Date: 08th Sep’25</p>
        </header>

        <div className="terms-content">
          <section className="terms-section">
            <h2 className="terms-section-title">1. Acceptance of Terms</h2>
            <p className="terms-section-text">
              By accessing or using our services, you acknowledge that you have read, understood, and agree 
              to be bound by these Terms, as well as applicable policies from WhatsApp (Meta) and relevant laws. 
              If you do not agree, you must not use our services.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">2. Services Provided</h2>
            <ul className="terms-list">
              <li className="terms-list-item">We provide WhatsApp Business API solutions, including account setup, onboarding, template approval, integrations, analytics, and technical support.</li>
              <li className="terms-list-item">We endeavor to ensure platform availability and functionality, but we do not guarantee uninterrupted service.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">3. User Obligations</h2>
            <ul className="terms-list">
              <li className="terms-list-item">Provide accurate information and necessary documentation during onboarding.</li>
              <li className="terms-list-item">Obtain valid consent from recipients before sending WhatsApp messages.</li>
              <li className="terms-list-item">Comply with WhatsApp (Meta) policies, including Business Solution Terms and Business Policy.</li>
              <li className="terms-list-item">Not use our services to send illegal, fraudulent, offensive, or unauthorized content.</li>
              <li className="terms-list-item">Maintain sufficient wallet balance for service usage (if applicable).</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">4. Account Security</h2>
            <p className="terms-section-text">
              You are responsible for maintaining the confidentiality of your account credentials. Any activity 
              under your account is your responsibility. Notify us immediately if you suspect unauthorized access.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">5. Data Retention and Privacy</h2>
            <ul className="terms-list">
              <li className="terms-list-item">Your data will be processed in accordance with our Privacy Policy.</li>
              <li className="terms-list-item">Retention of chat logs, reports, and related data will follow applicable agreements such as the Statement of Work (SOW) or Non-Disclosure Agreement (NDA).</li>
              <li className="terms-list-item">Upon termination of services, data will be deleted within the specified period, unless required otherwise by law.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">6. Payments and Fees</h2>
            <ul className="terms-list">
              <li className="terms-list-item">Charges are based on WhatsApp (Meta) pricing and service usage, as agreed during onboarding.</li>
              <li className="terms-list-item">Refunds, if applicable, will be processed within 30 working days, subject to applicable taxes and service verification.</li>
              <li className="terms-list-item">Usage-based charges are generally non-refundable, except in cases of verified service failure.</li>
              <li className="terms-list-item">For customers using auto-pay, the required balance will be automatically deducted.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">7. Suspension or Termination</h2>
            <ul className="terms-list">
              <li className="terms-list-item">We may suspend or terminate your account immediately for breach of these Terms or WhatsApp/Meta policies.</li>
              <li className="terms-list-item">Termination does not relieve you of outstanding fees. Post-termination, we will delete your data within the agreed retention period.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">8. Intellectual Property</h2>
            <ul className="terms-list">
              <li className="terms-list-item">All platform features, content, software, and intellectual property remain the sole property of Manthan IT Solutions or its licensors.</li>
              <li className="terms-list-item">You are granted a limited, non-exclusive, non-transferable license to use our services in accordance with these Terms.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">9. Limitation of Liability</h2>
            <ul className="terms-list">
              <li className="terms-list-item">We shall not be liable for any indirect, incidental, or consequential damages arising from your use of the services.</li>
              <li className="terms-list-item">Our total liability shall not exceed the amount paid by you for the service during the preceding 12 months.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">10. Indemnification</h2>
            <p className="terms-section-text">
              You agree to indemnify, defend, and hold harmless Manthan IT Solutions and its affiliates from 
              any claims, liabilities, damages, or expenses arising out of your use of the services, violation 
              of these Terms, or violation of WhatsApp (Meta) policies or applicable laws.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">11. Force Majeure</h2>
            <p className="terms-section-text">
              We shall not be liable for delays or failures caused by events beyond our reasonable control, 
              including natural disasters, strikes, governmental actions, or technical failures.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">12. Governing Law and Jurisdiction</h2>
            <p className="terms-section-text">
              These Terms shall be governed by the laws of India. Any disputes shall be subject to the exclusive 
              jurisdiction of courts in New Delhi, India.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="terms-section-title">13. Amendments</h2>
            <p className="terms-section-text">
              We may update these Terms from time to time. Updated Terms will be posted with the revised “Last Updated” date. 
              Continued use of our services constitutes acceptance of the updated Terms.
            </p>
          </section>

          <section className="terms-section terms-contact">
            <h2 className="terms-section-title">14. Contact Us</h2>
            <div className="terms-contact-info">
              <p className="terms-company-name">Manthan IT Solutions</p>
              <address className="terms-address">
                Ground Floor, 27, Jangpura Extension,<br />
                Opp. Shahi Masjid Road, Bhogal,<br />
                New Delhi – 110014, India
              </address>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

export default TermsConditions
